export const IconExportArrow = (props) => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.33301 5.66663L7.99967 10.3333L12.6663 5.66663" stroke="#1A1A1B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}